// extracted by mini-css-extract-plugin
export default {"zoomModal":"H2-z","image":"I2-z","button":"J2-z","isOverlayShown":"K2-z"};